import React from 'react';
import { Drawer, IconButton, Tooltip } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import styled from 'styled-components/macro';

const DrawerStyle = styled.div`
  flex: 1;
  background-color: #fff;
  min-height: 100vh;
  width: ${({ drawerWidth }) => drawerWidth};
  max-width: 99.5vw;
  min-width: ${({ isMobile }) => (isMobile ? '99.5vw' : '42em')};
`;

const CloseDrawerBtn = styled(IconButton)`
  && {
    position: fixed;
    right: 12px;
    top: 0;
    padding: 0.25em;
    z-index: 9999;
    transition: 0.5s;
  }

  &:hover {
    color: #4c84ff;
  }
`;

const Dragger = styled.div`
  position: absolute;
  position: sticky;
  top: 0;
  left: 0;
  float: left;
  height: 100vh;
  width: ${({ isResizing }) => (isResizing ? '8px' : '4px')};
  z-index: 999;
  background-color: ${({ isResizing }) => (isResizing ? '#4c84ff' : '#dedede')};
  cursor: ew-resize;
  transition: 0.5s;

  &:hover {
    background-color: #4c84ff;
    width: 8px;
  }

  body {
    ${({ isResizing }) => isResizing && 'cursor: ew-resize;'}
  }
`;

const ResizableDrawerView = props => {
  return (
    <Drawer open={props.open} anchor={props.anchor} onClose={props.onClose}>
      <Tooltip title="Close drawer" arrow>
        <CloseDrawerBtn
          size="small"
          onClick={props.onClose}
          data-testid="closeDrawer"
        >
          <Clear />
        </CloseDrawerBtn>
      </Tooltip>
      <Dragger
        onMouseDown={props.handleMouseDown}
        isResizing={props.isDraggerStyleEnabled}
      />
      <DrawerStyle drawerWidth={props.drawerWidth} isMobile={props.isMobile}>
        {props.children}
      </DrawerStyle>
    </Drawer>
  );
};

export default ResizableDrawerView;
